import React from 'react';
import { ClipboardTextIcon } from '@phosphor-icons/react';
import { Tab } from '../../../../components';
import CustomImageryProps from "./CustomImageryProps";

const CustomImagery = () => {

    const items = [
        {
            icon: (<ClipboardTextIcon/>),
            content: (<CustomImageryProps/>),
            title: 'Image Properties',
            is_active: true,
        },
    ];

    return (<Tab items={items}/>);
}

export default CustomImagery;